import { Injectable } from "@angular/core";
import { ApiRequestType } from "@models/app.models";
import { BehaviorSubject, Observable, map } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class ApiPendingRequestsService {
  private pendingRequestsMap = new Map<ApiRequestType, number>();
  private pendingRequestsSubject = new BehaviorSubject<Map<ApiRequestType, number>>(new Map());

  pendingRequests$: Observable<Map<ApiRequestType, number>> = this.pendingRequestsSubject.asObservable();

  increment(requestType: ApiRequestType): void {
    const currentCount = this.pendingRequestsMap.get(requestType) || 0;
    this.pendingRequestsMap.set(requestType, currentCount + 1);
    this.pendingRequestsSubject.next(this.pendingRequestsMap);
  }

  decrement(requestType: ApiRequestType): void {
    const currentCount = this.pendingRequestsMap.get(requestType) || 0;
    if (currentCount > 0) {
      this.pendingRequestsMap.set(requestType, currentCount - 1);
      this.pendingRequestsSubject.next(this.pendingRequestsMap);
    }
  }

  hasActiveRequests(requestType: ApiRequestType): Observable<boolean> {
    return this.pendingRequests$.pipe(
      map(requestMap => (requestMap.get(requestType) || 0) > 0)
    );
  }
}
